import { render, staticRenderFns } from "./productInfo2.vue?vue&type=template&id=d72c9290"
import script from "./productInfo2.vue?vue&type=script&lang=js"
export * from "./productInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports